import React from 'react'
import 'regenerator-runtime/runtime'
import Hashtag from '../../routes/Hashtag'
import { DEFAULT_SUB_MENU, ROUTES } from '../../constants/navigation'
import { withHeaderOptions } from '../../hoc/withHeaderOptions'
import {
  addDisableOverscroll,
  addRouteType,
  addSecondaryMenu
} from '../../utils/navigation'
import Head from 'next/head'

const Metatags = ({ hashtag }) => (
  <Head>
    <title>{`#${hashtag} hashtag on DecorMatters`}</title>
    <meta
      name="description"
      content={`Explore DecorMatters designs and find inspiration from '#${hashtag}' hashtag.`}
    />
    <meta name="twitter:card" content="summary" />
    <meta
      name="twitter:site"
      content={`https://www.decormatters.com/hashtag/${hashtag}`}
    />
    <meta
      name="twitter:title"
      content={`#${hashtag} hashtag on DecorMatters`}
    />
    <meta name="twitter:site" content="@decormattersapp" />
    <meta
      property="og:url"
      content={`https://www.decormatters.com/hashtag/${hashtag}`}
    />
    <meta property="og:title" content={`#${hashtag} hashtag on DecorMatters`} />
    <meta
      property="og:description"
      content={`Explore DecorMatters designs and find inspiration from '#${hashtag}' hashtag.`}
    />
  </Head>
)

const Routes = ({ hashtag }) => {
  if (typeof window === 'undefined') return <Metatags hashtag={hashtag} />

  return (
    <>
      <Metatags hashtag={hashtag} />
      <Hashtag />
    </>
  )
}

export default withHeaderOptions(Routes)(
  addSecondaryMenu(DEFAULT_SUB_MENU),
  addRouteType(ROUTES.COMMUNITY.EXPLORE),
  addDisableOverscroll()
)

export async function getServerSideProps({ query }) {
  try {
    return {
      props: {
        hashtag: query.hashtag
      }
    }
  } catch (error) {
    return {
      props: {}
    }
  }
}
